import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import 'normalize.css/normalize.css'; // a modern alternative to CSS resets
import localFun from '@/utils/local-ope';
import Element from 'element-ui';
import '@/styles/element-variables.scss';
import '@/styles/index.scss'; // global css
import '@/icons/iconfont/icon-font.css';
import './directives';
import '@/views/h5/permission';
import App from './App';
import store from './store';
import router from './router';
import './icons'; // icon
import './permission'; // permission control
import * as filters from './filters'; // global filters
import axios from 'axios';
import { detectZoom } from './utils/validate';
import dayjs from 'dayjs';
import Aegis from 'aegis-web-sdk';
import { Table } from 'element-ui';

import tableSticky from '@/components/SmartTable/utils/tableSticky.js';
import './utils/app-version.js';

// 设置全局 CSS 变量
document.documentElement.style.setProperty(
  '--minio-url',
  import.meta.env.VITE_MINIO_URL + `/static/qywx/work-bench/`
);

if (import.meta.env.VITE_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_DSN,
    environment: import.meta.env.VITE_ENV,
    integrations: [
      new VueIntegration({
        Vue,
        attachProps: true
      })
    ],
    beforeSend(event, hint) {
      if (
        event.message === '登录过期' ||
        hint?.originalException?.message === '登录过期' ||
        !import.meta.env.PROD
      ) {
        if (hint?.originalException && !import.meta.env.PROD) {
          console.error(hint.originalException);
        }

        return null;
      } else {
        const userInfo = store?.state?.app?.userData?.userInfo || {};
        // 给sentry用户数据中添加用户、设备信息
        event.user = {
          date: dayjs().format('YYYY-MM-DD HH:mm:ss'),
          language: navigator.language,
          detectZoom: detectZoom(),
          enterpriseId: localFun.get('enterpriseId'),
          enterpriseName: localFun.get('enterpriseName'),
          mobile: localFun.get('mobile'),
          sessionId: localFun.get('sessionId'),
          name: userInfo.name
        };
        // 添加自定义标签
        event.tags = {
          enterpriseName: localFun.get('enterpriseName')
        };
        return event;
      }
    }
  });
}

if (
  import.meta.env.MODE == 'master' &&
  import.meta.env.VITE_ENV == 'master'
) {
  new Aegis({
    id: 'XVmaGHgdeDjPX2nn8O', // 上报 id
    uin: 'RepresentativeWorkPlatform', // 用户唯一 ID（可选）
    reportApiSpeed: true, // 接口测速
    reportAssetSpeed: true, // 静态资源测速
    spa: true, // spa 应用页面跳转的时候开启 pv 计算
    hostUrl: 'https://rumt-zh.com'
  });
}

Vue.use(Element, {
  size: 'small'
});
Table.props.border.default = true;
Vue.component('el-table', Table);
// register global utility filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
Vue.directive('tableSticky', tableSticky);
Vue.config.productionTip = false;
Vue.prototype.Sentry = Sentry;
Vue.prototype.$axios = axios;

const app = new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App)
});
window.app = app;

// 检测是否是上药回调（code 参数）
const params = new URLSearchParams(window.location.search);
if (params.has('code')) {
  const code = params.get('code');
  const state = params.get('state');
  // 先清理 URL 中的查询参数，然后设置 hash 路由
  window.location.href = `${
    window.location.pathname
  }#/shaphar/callback?code=${encodeURIComponent(
    code
  )}&state=${encodeURIComponent(state)}`;
}
